export const householdListingFeesFieldgroup = [
  'rentPrice',
  'securityDepositIncreaseMultiplier',
];
